import Vue from "vue";
import "@/assets/reset.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookie from "vue-cookie";
import { Message } from "element-ui";
import VueClipboard from "vue-clipboard2";
import locale from "element-ui/lib/locale/lang/zh-TW";
import VCharts from "v-charts";

import VueQuillEditor from "vue-quill-editor";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "../src/assets/js/socketHandler";
import AFTableColumn from "af-table-column";
import "./assets/element-variable.scss";

Vue.use(VueClipboard);
Vue.use(VueQuillEditor);
Vue.use(VueCookie);
Vue.use(VCharts);

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });

Vue.use(AFTableColumn);
// VUE prototype
import "./assets/js/axiosSetting";
import "./assets/js/returnTIme";
import "./assets/js/returnPermission";

Vue.prototype.$onCopy = function() {
  Message.success("已複製");
};

Vue.prototype.$openUser = function(id) {
  window.open(`/?id=${id}`);
};
// 小數點
import decimalPoint from "./filter/decimalPoint.js";
import thousands from "./filter/thousands.js";

ElementUI.Dialog.props.closeOnClickModal.default = false;

Vue.filter("decimalPoint", decimalPoint);
Vue.filter("thousands", thousands);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
